import _ from 'lodash';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { decode as base64_decode } from 'base-64';
import TableView from '../../../Widgets/TableView';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import React, { useEffect, useRef, useState } from 'react';
import InputComponent from '../../../Widgets/InputComponent';
import localStorage from '../../../../../utils/localStorage';
import translation from '../../../../../commons/translation';

import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { API_DEVICE, API_INSPECTIONCONFIG } from '../../../../../commons/api';
import { Form, message, Select, DatePicker, Input, TimePicker, Modal, Button, Typography } from 'antd';
import {
  getDeviceList,
  getSitesList,
  getUsersList,
  getLocationByAsset,
  submitScheduleInspection,
  getJobPlanById,
  getscheduleInspectByID,
  getMasterList,
  getStatusListPM,
  getWorkTypesEInspec,
  getFrequency,
  getJobPlansListByEquipmentandType
} from '../../../Utils/FormCalls';
import { StyledBox, StyledBoxHeader, StyledBoxLabel } from '../../../CSS/style';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { StyledHomepageSides } from '../../../../../commons/styles/layout';

const { Option } = Select;
const urlList = {
  list: API_INSPECTIONCONFIG.GET
};

const ELogScheduleDetails = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  const [sitesList, setSitesList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [workTypesList, setWorkTypesList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [formObject, setFormObject] = useState(
    props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {}
  );
  const [JobPlansList, setJobPlansList] = useState([]);
  const [frequencyObject, setFrequencyObject] = useState({});
  const [tableData, setTableData] = useState([]);
  const [days, setDays] = useState([]);
  const [inspectionMasterList, setInspectionMasterList] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);
  const [SelectedWorkType, setSelectedWorkType] = useState('');
  const searchInputRef = useRef(null);
  const formHeader = useRef();
  dayjs.extend(timezone);
  dayjs.extend(utc);

  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      let value = 0;
      let daysArray = [];
      for (let i = value + 1; i <= 31; i++) {
        daysArray.push(i);
      }
      handleChange(dayjs().add(1, 'days'), 'EffectiveStartDate');
      setDays(daysArray);
      let inspectionMasterList = await getMasterList(urlList.list);
      setInspectionMasterList(inspectionMasterList);

      let sitesList = await getSitesList();
      let formObject = formHeader.current && formHeader.current.getFieldsValue();
      formObject = {
        ...formObject,
        SiteId: sitesList && sitesList[0] && sitesList[0].Id ? sitesList[0].Id : ''
      };
      formHeader.current && formHeader.current.setFieldsValue(formObject);
      setSitesList(sitesList);
      // setFormObject(formObject);

      try {
        let deviceList = await getDeviceList();
        setDeviceList(deviceList);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      try {
        let usersList = await getUsersList();
        setUsersList(usersList);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      let workTypes = await getWorkTypesEInspec('ESchedule');
      setWorkTypesList(workTypes);

      try {
        let Status = await getStatusListPM();
        setStatusList(Status);
        if (formObject && !formObject.Id) {
          handleChange(
            Status && Status[0] && Status[0]['Value'] ? Status[0]['Value'] : null,
            'StatusId'
          );
        }
      } catch (error) {
        message.warning(`${error.message}`);
      }

      try {
        let frequencyList = await getFrequency();
        let frequencyObject = {};
        frequencyList &&
          Array.isArray(frequencyList) &&
          frequencyList.map((freq) => {
            frequencyObject[freq.Key] = freq.Value;
            return {};
          });
        setFrequencyList(frequencyList);
        setFrequencyObject(frequencyObject);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
    };
    fetchData();
  }, []);
  const _getDataById = async (Id) => {
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/ELogScheduleDetails/');
    let formId = base64_decode(path[1]);
    if (formId !== 'new') {
      let data = await getscheduleInspectByID(formId);

      _.cloneDeepWith(data, (value) => {
        return value && value !== null
          ? {
            ...value,
            ...(value['CreatedDate'] = value.CreatedDate
              ? dayjs.utc(value.CreatedDate, 'YYYY-MM-DD HH:mm:ss').tz(props.currentTimeZone)
              : null),
            ...(value['EffectiveStartDate'] = value.EffectiveStartDate
              ? dayjs
                .utc(value.EffectiveStartDate, 'YYYY-MM-DD HH:mm:ss')
                .tz(props.currentTimeZone)
              : null),
            ...(value['EffectiveEndDate'] = value.EffectiveEndDate
              ? dayjs.utc(value.EffectiveEndDate, 'YYYY-MM-DD HH:mm:ss').tz(props.currentTimeZone)
              : null),
            ...(value['CreationTime'] = value.CreationTime
              ? dayjs.utc(value.CreationTime, 'YYYY-MM-DD HH:mm:ss').tz(props.currentTimeZone)
              : null),
            ...(value['inspectionData'] &&
              value['inspectionData'].map((item, i) => {
                return value['inspectionData'][i]
                  ? (value['inspectionData'][i]['EffectiveStartDate']
                    ? (value['inspectionData'][i]['EffectiveStartDate'] = dayjs.utc(
                      value['inspectionData'][i]['EffectiveStartDate'],
                      'YYYY-MM-DD HH:mm:ss'
                    ))
                    : null,
                    value['inspectionData'][i]['EffectiveEndDate']
                      ? (value['inspectionData'][i]['EffectiveEndDate'] = dayjs.utc(
                        value['inspectionData'][i]['EffectiveEndDate'],
                        'YYYY-MM-DD HH:mm:ss'
                      ))
                      : null,
                    value['inspectionData'][i]['CreationTime']
                      ? (value['inspectionData'][i]['CreationTime'] = dayjs.utc(
                        value['inspectionData'][i]['CreationTime'],
                        'YYYY-MM-DD HH:mm'
                      ))
                      : null)
                  : null;
              }))
          }
          : _.noop();
      });

      formObject = {
        ...data,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };

      getJobPlanList(data.Equipment);
      let inspectionMasterList = await getMasterList(urlList.list);
      formHeader.current && formHeader.current.setFieldsValue(formObject);
      let workTypes = await getWorkTypesEInspec('ESchedule');

      let SelectedWorkType = '';
      workTypes &&
        Array.isArray(workTypes) &&
        workTypes.map((WorkType) => {
          if (WorkType.Value === formObject.WorkTypeId) {
            SelectedWorkType = WorkType.Key;
          }
          return WorkType.Key;
        });
      setSelectedWorkType(SelectedWorkType);
      setFormObject(formObject);
      setInspectionMasterList(inspectionMasterList);
    } else if (Id) {
      let data = await getscheduleInspectByID(Id);

      _.cloneDeepWith(data, (value) => {
        return value && value !== null
          ? {
            ...value,
            ...(value['CreatedDate'] = value.CreatedDate
              ? dayjs.utc(value.CreatedDate, 'YYYY-MM-DD HH:mm:ss').tz(props.currentTimeZone)
              : null),
            ...(value['EffectiveStartDate'] = value.EffectiveStartDate
              ? dayjs
                .utc(value.EffectiveStartDate, 'YYYY-MM-DD HH:mm:ss')
                .tz(props.currentTimeZone)
              : null),
            ...(value['EffectiveEndDate'] = value.EffectiveEndDate
              ? dayjs.utc(value.EffectiveEndDate, 'YYYY-MM-DD HH:mm:ss').tz(props.currentTimeZone)
              : null),
            ...(value['CreationTime'] = value.CreationTime
              ? dayjs.utc(value.CreationTime, 'YYYY-MM-DD HH:mm:ss').tz(props.currentTimeZone)
              : null),
            ...(value['inspectionData'] &&
              value['inspectionData'].map((item, i) => {
                return value['inspectionData'][i]
                  ? (value['inspectionData'][i]['EffectiveStartDate']
                    ? (value['inspectionData'][i]['EffectiveStartDate'] = dayjs.utc(
                      value['inspectionData'][i]['EffectiveStartDate'],
                      'YYYY-MM-DD HH:mm:ss'
                    )).tz(props.currentTimeZone)
                    : null,
                    value['inspectionData'][i]['EffectiveEndDate']
                      ? (value['inspectionData'][i]['EffectiveEndDate'] = dayjs.utc(
                        value['inspectionData'][i]['EffectiveEndDate'],
                        'YYYY-MM-DD HH:mm:ss'
                      )).tz(props.currentTimeZone)
                      : null,
                    value['inspectionData'][i]['CreationTime']
                      ? (value['inspectionData'][i]['CreationTime'] = dayjs.utc(
                        value['inspectionData'][i]['CreationTime'],
                        'YYYY-MM-DD HH:mm'
                      )).tz(props.currentTimeZone)
                      : null)
                  : null;
              }))
          }
          : _.noop();
      });
      formObject = {
        ...data,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };

      getJobPlanList(data.Equipment);
      let inspectionMasterList = await getMasterList(data.list);
      formHeader.current && formHeader.current.setFieldsValue(formObject);
      setFormObject(formObject);
      setInspectionMasterList(inspectionMasterList);
      let workTypes = await getWorkTypesEInspec('ESchedule');

      let SelectedWorkType = '';
      workTypes &&
        Array.isArray(workTypes) &&
        workTypes.map((WorkType) => {
          if (WorkType.Value === formObject.WorkTypeId) {
            SelectedWorkType = WorkType.Key;
          }
          return WorkType.Key;
        });
      setSelectedWorkType(SelectedWorkType);
    }
    setFormObject(formObject);
  };

  const handleChange = async (value, key) => {
    let formObject = formHeader.current && formHeader.current.getFieldsValue();
    if (key === 'Equipment') {
      let selectedDevice = deviceList.filter((item) => item.AliasCode === value);
      let location = await getLocationByAsset(selectedDevice[0] && selectedDevice[0].Asset);
      formObject = {
        ...formObject,
        [key]: value,
        EquipmentDescription: selectedDevice[0].AliasCode,
        Location: location.AssetCode,
        LocationDescription: location.Name
      };
      formHeader.current && formHeader.current.setFieldsValue(formObject);
      setFormObject(formObject);
    }
    if (key === 'CreatedBy') {
      let selectedUser = usersList.filter((item) => item.Id === value);
      formObject = {
        ...formObject,
        [key]: value,
        Name: selectedUser[0]['UserName'],
        Phone: selectedUser[0]['MobileNumber'],
        Email: selectedUser[0]['Email']
      };
    } else if (
      key === 'TargetStart' ||
      key === 'TargetFinish' ||
      key === 'ActualStart' ||
      key === 'ActualFinish' ||
      key === 'RecordDate'
    ) {
      formObject = {
        ...formObject,
        [key]: dayjs(value).format('YYYY-MM-DD')
      };
    } else if (key === 'WorkTypeId') {
      formObject = {
        ...formObject,
        FrequencyId: '',
        Days: [],
        [key]: value
      };

      let SelectedWorkType = '';
      workTypesList &&
        Array.isArray(workTypesList) &&
        workTypesList.map((WorkType) => {
          if (WorkType.Value === value) {
            SelectedWorkType = WorkType.Key;
          }
          return WorkType.Key;
        });
      setSelectedWorkType(SelectedWorkType);
    } else if (key === 'CreationTime') {
      formObject = {
        ...formObject,
        [key]: dayjs(value, 'HH:mm')
      };
    } else {
      formObject = {
        ...formObject,
        [key]: value
      };
    }
    formHeader.current && formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const onFinish = async (values) => {
    let userId =
      props.userProfile && props.userProfile.user && props.userProfile.user.Id
        ? props.userProfile.user.Id
        : '';
    let WorkTypeInspection =
      workTypesList && Array.isArray(workTypesList)
        ? workTypesList.filter((workType) => workType.Key === 'Inspection Work')
        : [];
    let InspectionId =
      WorkTypeInspection && WorkTypeInspection[0] ? WorkTypeInspection[0].Value : undefined;

    // If WorkType is InspectionWork
    if (formObject && formObject.WorkTypeId && formObject.WorkTypeId === InspectionId) {
      let InspectionData = [];
      let InspectionDataForm =
        formObject && formObject.InspectionData ? formObject.InspectionData : [];
      if (
        InspectionDataForm &&
        Array.isArray(InspectionDataForm) &&
        InspectionDataForm.length > 0
      ) {
        let editableList = [];
        editableList = InspectionDataForm.filter((specifi) => {
          return specifi.editable === true;
        });
        if (editableList && Array.isArray(editableList) && editableList.length === 0) {
          InspectionData = InspectionDataForm.map((spec) => {
            delete spec.editable;
            delete spec.key;
            let creationTime = dayjs(spec.CreationTime).format('HH:mm');
            let startDate = dayjs(spec.EffectiveStartDate).format(`YYYY-MM-DD ${creationTime}`);
            let endDate = dayjs(spec.EffectiveEndDate).format(`YYYY-MM-DD ${creationTime}`);
            return {
              ...spec,
              CreationTime: spec.CreationTime
                ? dayjs.utc(spec.CreationTime).format('YYYY-MM-DD HH:mm:ss')
                : undefined,
              EffectiveStartDate: spec.EffectiveStartDate
                ? dayjs(startDate).utc().format('YYYY-MM-DD HH:mm:ss')
                : undefined,
              EffectiveEndDate: spec.EffectiveEndDate
                ? dayjs(endDate).utc().format('YYYY-MM-DD HH:mm:ss')
                : undefined
            };
          });
          let payload = {
            ...values,
            InspectionData,
            ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
            ...(formObject && formObject.Id ? { UpdatedBy: userId } : {})
          };
          let statusResponse = await submitScheduleInspection(payload);
          if (statusResponse && statusResponse.Id) {
            message.success(statusResponse.message);
            _getDataById(statusResponse.Id);
          } else if (statusResponse && statusResponse.Error) {
            message.error(statusResponse.Error);
          }
        } else {
          message.warning('Please save inspection before submitting');
        }
      } else {
        message.warning('Please add at least one inspection before submitting');
      }
    } else {
      let creationTime = dayjs(values.CreationTime).format('HH:mm:ss');

      let startDate = dayjs(values.EffectiveStartDate).format(`YYYY-MM-DD ${creationTime}`);

      let endDate = dayjs(values.EffectiveEndDate).format(`YYYY-MM-DD ${creationTime}`);
      let payload = {
        ...formObject,
        ...values,
        CreationTime: values.CreationTime
          ? dayjs.utc(values.CreationTime).format('YYYY-MM-DD HH:mm:ss')
          : undefined,
        EffectiveStartDate: values.EffectiveStartDate
          ? dayjs(startDate).utc().format(`YYYY-MM-DD ${creationTime}`)
          : undefined,
        EffectiveEndDate: values.EffectiveEndDate
          ? dayjs(endDate).utc().format(`YYYY-MM-DD ${creationTime}`)
          : undefined,
        ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
        ...(formObject && formObject.Id ? { UpdatedBy: userId } : {})
      };
      let statusResponse = await submitScheduleInspection(payload);
      if (statusResponse && statusResponse.message) {
        message.success(statusResponse.message);
        _getDataById(statusResponse.Id);
      } else if (statusResponse && statusResponse.Error) {
        message.error(statusResponse.Error);
      }
    }
  };

  const getJobPlanList = async (Equipment) => {
    let JobPlansList = await getJobPlansListByEquipmentandType(
      'Active',
      Equipment
      // 'fieldDataType'
    );

    setJobPlansList(JobPlansList);
  };
  const TableDropdownChange = async (value) => {
    let currentFormObject = formHeader.current && formHeader.current.getFieldsValue();
    let selectedDevice = deviceList.filter((item) => item.AliasCode === value.AliasCode);
    await getLocationByAsset(selectedDevice[0] && selectedDevice[0].Asset);

    currentFormObject = {
      ...currentFormObject,
      Equipment: value.AliasCode,
      EquipmentDescription: value.Name,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode,
      Location: value.AssetDisplayCode,
      AssetDisplayCode: value.AssetDisplayCode,
      LocationDescription: value.LocationDescription
    };

    if (formHeader.current) {
      formHeader.current.setFieldsValue(currentFormObject);
    }
    setFormObject(currentFormObject);
    setVisible(false);
    getJobPlanList(value.AliasCode);
  };
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}>
          {translation(props.translationCache, `Search`)}
        </Button>
        <Button type="primary" onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const getDeviceData = async () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');

    const headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {
      const { data } = await axios(headers);
      setTableData(data);
      setFormObject(formHeader.current ? formHeader.current.getFieldsValue() : {});
      // Assuming you want to set some state based on the key
      // You can use a state variable to manage this if needed
      // For example, if you have a state variable for the key:
      // setSomeState({ [key]: true });
    } catch (error) {
      console.error('Error fetching device data:', error);
    }
  };
  const onModalCancel = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setVisible(false);
    }
  };

  const onModalOk = () => {
    setVisible(false);
  };

  const jobPlanOnChange = async (value) => {
    let jobplanData = await getJobPlanById(value, 'withoutId');
    let formObject = formHeader.current && formHeader.current.getFieldValue();
    formObject = {
      ...formObject,
      JobPlanDescription:
        jobplanData && jobplanData.JobPlanDescription ? jobplanData.JobPlanDescription : ''
    };
    formHeader.current && formHeader.current.setFieldsValue(formObject);
    setFormObject({
      ...formObject,
      JobPlan: jobplanData,
      JobPlanDescription: jobplanData.JobPlanDescription
    });
  };

  const saveTableViewData = (e) => {
    let formObject = formHeader.current && formHeader.current.getFieldsValue();

    formObject = {
      ...formObject,
      InspectionData: e
    };
    setFormObject(formObject);
    formHeader.current && formHeader.current.setFieldsValue(formObject);
  };

  const filterWorkType = () => {
    if (workTypesList && Array.isArray(workTypesList)) {
      return workTypesList.filter((item) => {
        return item.Value === formHeader.current && formHeader.current.getFieldValue('WorkTypeId');
      });
    }
    return [];
  };
  const filteredWorkTypes = filterWorkType();

  const inspectionColumns = [
    {
      title: 'Inspection Id',
      dataIndex: 'InspectionId',
      key: 'InspectionId',
      widget: 'select',
      required: true,
      table: {
        url: API_INSPECTIONCONFIG.Getinspectionswithkey,
        method: 'GET'
      }
    },
    {
      title: 'Inspection Description',
      dataIndex: 'Description',
      key: 'Description',
      widget: 'input',
      required: true,
      disable: true
    },
    {
      title: 'Effective Start Date',
      dataIndex: 'EffectiveStartDate',
      key: 'EffectiveStartDate',
      widget: 'datePicker',
      required: true,
      datePickerValidation: { disable: 'past' },
      render: (text) => {
        return {
          children: text !== undefined ? <div>{dayjs(text).format('YYYY-MM-DD')}</div> : null
        };
      }
    },
    {
      title: 'Effective End Date',
      dataIndex: 'EffectiveEndDate',
      key: 'EffectiveEndDate',
      widget: 'datePicker',
      datePickerValidation: { disable: 'past' },
      required: true,
      render: (text) => {
        return {
          children: text !== undefined ? <div>{dayjs(text).format('YYYY-MM-DD')}</div> : null
        };
      }
    },
    {
      title: translation(translation, constant.inspectionCreationTime),
      dataIndex: 'CreationTime',
      key: 'CreationTime',
      widget: 'TimePicker',
      required: true,
      render: (text) => {
        return {
          children: text !== undefined ? <div>{dayjs(text).format('HH:mm')}</div> : null
        };
      }
    }
  ];

  return (
    <StyledHomepageSides>
      <Form
        name="SR"
        ref={formHeader}
        onFinish={onFinish}
        initialValues={formObject}
        layout="vertical"
      >
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Button type="primary" htmlType="submit">
            {translation(props.translationCache, constant.submit)}
          </Button>
        </div>
        <StyledBoxHeader>
          <StyledBox>
            <Form.Item
              label={translation(props.translationCache, constant.Name)}
              name="Name"
              rules={[
                { required: true, message: translation(props.translationCache, 'Input Name!') }
              ]}>
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(props.translationCache, 'Name')}
                value={formObject.Name}
                onChange={(e) => handleChange(e, 'Name')}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.description)}
              name="Description"
              rules={[
                {
                  required: true,
                  message: translation(props.translationCache, 'Input Description!')
                }
              ]}>
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(props.translationCache, 'Input Description')}
                onChange={(e) => handleChange(e, 'Description')}
              />
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.workType)}
              name="WorkTypeId"
              rules={[
                { required: true, message: translation(props.translationCache, 'Select Work Type') }
              ]}>
              <Select
                placeholder={translation(props.translationCache, 'Select Work Type')}
                onChange={(value) => handleChange(value, 'WorkTypeId')}
                disabled={formObject && formObject.Id ? true : false}
                style={{ width: '100%' }}>
                {workTypesList &&
                  Array.isArray(workTypesList) &&
                  workTypesList.map((workType, index) => {
                    return (
                      <Option key={index} value={workType.Value}>
                        {translation(props.translationCache, workType.Key)}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation(props.translationCache, constant.site)}
              name="SiteId"
              rules={[{ required: true, message: 'Select Site' }]}>
              <Select
                placeholder={translation(props.translationCache, 'Select Site')}
                onChange={(value) => handleChange(value, 'SiteId')}
                style={{ width: '100%' }}
                disabled>
                {sitesList &&
                  Array.isArray(sitesList) &&
                  sitesList.map((site, index) => {
                    return (
                      <Option key={index} value={site.Id}>
                        {' '}
                        {site.Name}{' '}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            {SelectedWorkType && SelectedWorkType === 'Common Work' ? (
              <>
                <Form.Item
                  label={translation(props.translationCache, constant.equipment)}
                  name="DisplayCode"
                  rules={[{ required: true, message: 'Select Equipment' }]}>
                  <Input
                    style={{
                      width: '100%',
                      flex: '50%'
                    }}
                    disabled={true}
                    placeholder={translation(props.translationCache, 'Select Equipment')}
                    suffix={
                      <DownOutlined
                        style={{
                          color: '#1a3b5c',
                          cursor: formObject && formObject.Id ? 'not-allowed' : null,
                          opacity: formObject && formObject.Id ? '0.8' : null
                        }}
                        onClick={async (e) => {
                          e.preventDefault();
                          if (formObject && !formObject.Id) {
                            await getDeviceData();
                            setVisible(true);
                          }
                        }}
                      />
                    }
                  />
                </Form.Item>
                <Form.Item
                  label={translation(props.translationCache, constant.equipmentDescription)}
                  name="EquipmentDescription"
                  rules={[
                    {
                      required: true,
                      message: translation(
                        props.translationCache,
                        'Autopopulate based on equipment selection'
                      )
                    }
                  ]}>
                  <InputComponent
                    style={{ width: '100%' }}
                    disabled
                    placeholder={translation(
                      props.translationCache,
                      'Autopopulate based on equipment selection'
                    )}
                  />
                </Form.Item>
                <Form.Item
                  label={translation(props.translationCache, constant.Location)}
                  name="AssetDisplayCode"
                  rules={[
                    {
                      required: true,
                      message: translation(
                        props.translationCache,
                        'Autopopulate based on equipment selection'
                      )
                    }
                  ]}>
                  <InputComponent
                    style={{ width: '100%' }}
                    placeholder={translation(
                      props.translationCache,
                      'Autopopulate based on equipment selection'
                    )}
                    disabled={true}
                  />
                </Form.Item>
                <Form.Item
                  label={translation(props.translationCache, constant.locationDescription)}
                  name="LocationDescription"
                  rules={[
                    {
                      required: true,
                      message: translation(
                        props.translationCache,
                        'Autopopulate based on equipment selection'
                      )
                    }
                  ]}>
                  <InputComponent
                    style={{ width: '100%' }}
                    placeholder={translation(
                      props.translationCache,
                      'Autopopulate based on equipment selection'
                    )}
                    disabled={true}
                  />
                </Form.Item>
              </>
            ) : null}

            <Form.Item

              label={translation(props.translationCache, constant.createdBy)}
              name="CreatedBy"
              rules={[{ required: false, message: 'Select Created By' }]}>
              <Select
                style={{ width: '100%' }}
                disabled={true}
                placeholder={translation(props.translationCache, 'Created By')}
                onChange={(value) => handleChange(value, 'CreatedBy')}>
                {usersList &&
                  Array.isArray(usersList) &&
                  usersList.map((users, index) => {
                    return (
                      <Option key={index} value={users.Id}>
                        {' '}
                        {users.FirstName}{' '}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item

              label={translation(props.translationCache, constant.ActualStartDate)}
              name="CreatedDate"
              rules={[{ required: false, message: 'Created Date' }]}>
              <DatePicker
                format={'YYYY-MM-DD HH:mm:ss'}
                style={{ width: '100%' }}
                disabled={true}
                placeholder={translation(props.translationCache, 'Created Date')}
              />
            </Form.Item>
            <Form.Item

              label={translation(props.translationCache, constant.status)}
              name="StatusId"
              rules={[{ required: true, message: 'Please Select Status' }]}>
              <Select
                placeholder={translation(props.translationCache, 'Select Status')}
                onChange={(value) => handleChange(value, 'StatusId')}
                style={{ width: '100%' }}>
                {statusList &&
                  Array.isArray(statusList) &&
                  statusList.map((status, index) => {
                    return (
                      <Option key={index} value={status.Value}>
                        {translation(props.translationCache, status.Key)}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item name="Equipment"></Form.Item>
          </StyledBox>
        </StyledBoxHeader>

        {SelectedWorkType && SelectedWorkType === 'Common Work' ? (
          <>
            <StyledBoxHeader>

              <StyledBoxLabel>
                <Typography.Title level={5}>
                  {filteredWorkTypes && filteredWorkTypes[0] && filteredWorkTypes[0]['Key']
                    ? filteredWorkTypes[0]['Key']
                    : null}
                </Typography.Title>
              </StyledBoxLabel>
              <StyledBox>
                <Form.Item
                  label={translation(props.translationCache, constant.jobPlan)}
                  name="JobPlanId"
                  rules={[{ required: true }]}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder={translation(props.translationCache, 'Select JobPlan')}
                    onChange={(value) => jobPlanOnChange(value)}>
                    {JobPlansList &&
                      Array.isArray(JobPlansList) &&
                      JobPlansList.map((jobplan, index) => {
                        return (
                          <Option key={index} value={jobplan.Id}>
                            {jobplan.JobPlanName}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={translation(props.translationCache, constant.jobplanDescription)}
                  name="JobPlanDescription">
                  <InputComponent
                    style={{ width: '100%' }}
                    placeholder={translation(props.translationCache, 'Enter JobPlanDescription')}
                  />
                </Form.Item>
              </StyledBox>
            </StyledBoxHeader>
            {formHeader.current &&
              formHeader.current.getFieldValue('JobPlanId') &&
              formHeader.current.getFieldValue('JobPlanId') !== undefined ? (
              <StyledBoxHeader>
                <StyledBoxLabel>
                  <Typography.Title level={5}>
                    {translation(props.translationCache, 'Schedule')}
                  </Typography.Title>

                </StyledBoxLabel>
                <StyledBox>
                  <Form.Item

                    label={translation(props.translationCache, constant.effectiveStartDate)}
                    name="EffectiveStartDate"
                    rules={[{ required: true }]}>
                    <DatePicker
                      inputReadOnly={true}
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                      onChange={(value) => {
                        handleChange(value, 'EffectiveStartDate');
                      }}
                      disabledDate={(d) =>
                        !d ||
                        d.isAfter(
                          formHeader.current &&
                            formHeader.current.getFieldValue() &&
                            formHeader.current.getFieldValue()['EffectiveEndDate']
                            ? dayjs(formHeader.current.getFieldValue()['EffectiveEndDate'])
                              .add(1, 'day')
                              .format('YYYY-MM-DD')
                            : ''
                        ) ||
                        d.isBefore(dayjs().add(1, 'day').format('YYYY-MM-DD'))
                      }
                    />
                  </Form.Item>
                  <Form.Item

                    label={translation(props.translationCache, constant.effectiveEndDate)}
                    name="EffectiveEndDate">
                    <DatePicker
                      inputReadOnly={true}
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                      onChange={(value) => {
                        handleChange(value, 'EffectiveEndDate');
                      }}
                      disabledDate={(d) =>
                        !d ||
                        d.isBefore(formHeader.current &&
                          formHeader.current.getFieldValue() &&
                          formHeader.current.getFieldValue()['EffectiveStartDate']
                          ? dayjs(
                            formHeader.current.getFieldValue()['EffectiveStartDate']
                          ).format('YYYY-MM-DD')
                          : ''
                        ) ||
                        d.isBefore(dayjs().format('YYYY-MM-DD'))
                      }
                    />
                  </Form.Item>
                  <Form.Item

                    label={translation(props.translationCache, constant.frequency)}
                    name="FrequencyId"
                    rules={[{ required: true }]}>
                    <Select
                      style={{ width: '100%' }}
                      placeholder={translation(props.translationCache, 'Select Frequency')}
                      onChange={(value) => handleChange(value, 'FrequencyId')}>
                      {frequencyList &&
                        Array.isArray(frequencyList) &&
                        frequencyList.map((freq, index) => {
                          return (
                            <Option key={index} value={freq.Value}>
                              {translation(props.translationCache, freq.Key)}{' '}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                  {formObject.Id &&
                    formHeader &&
                    frequencyObject &&
                    formHeader.current &&
                    formHeader.current !== null &&
                    formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Daily'] ? (
                    <>
                      <Form.Item

                        label={translation(props.translationCache, constant.workOrderCreationTime)}
                        name="CreationTime"
                        rules={[{ required: true }]}>
                        <TimePicker
                          style={{ width: '100%' }}
                          format={'HH:mm'}
                          onChange={(value) => handleChange(value, 'CreationTime')}
                          allowClear={false}
                        />
                      </Form.Item>
                    </>
                  ) : null}
                  {formObject.Id &&
                    formHeader &&
                    frequencyObject &&
                    formHeader.current &&
                    formHeader.current !== null &&
                    formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Weekly'] ? (
                    <>
                      <Form.Item

                        label={translation(props.translationCache, constant.workOrderCreationTime)}
                        name="CreationTime"
                        rules={[{ required: true }]}>
                        <TimePicker
                          style={{ width: '100%' }}
                          format={'HH:mm'}
                          onChange={(value) => handleChange(value, 'CreationTime')}
                          allowClear={false}
                        />
                      </Form.Item>
                    </>
                  ) : null}
                  {formObject.Id &&
                    formHeader &&
                    frequencyObject &&
                    formHeader.current &&
                    formHeader.current !== null &&
                    formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Monthly'] ? (
                    <>
                      <Form.Item

                        label={translation(props.translationCache, constant.workOrderCreationTime)}
                        name="CreationTime"
                        rules={[{ required: true }]}>
                        <TimePicker
                          style={{ width: '100%' }}
                          format={'HH:mm'}
                          onChange={(value) => handleChange(value, 'CreationTime')}
                          allowClear={false}
                        />
                      </Form.Item>
                    </>
                  ) : null}

                  {!formObject.Id &&
                    formHeader &&
                    frequencyObject &&
                    formHeader.current &&
                    formHeader.current !== null &&
                    formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Daily'] ? (
                    <>
                      <Form.Item

                        label={translation(props.translationCache, constant.workOrderCreationTime)}
                        name="CreationTime"
                        rules={[{ required: true }]}>
                        <TimePicker
                          style={{ width: '100%' }}
                          format={'HH:mm'}
                          onChange={(value) => handleChange(value, 'CreationTime')}
                          allowClear={false}
                        />
                      </Form.Item>
                    </>
                  ) : null}
                  {!formObject.Id &&
                    formHeader &&
                    frequencyObject &&
                    formHeader.current &&
                    formHeader.current !== null &&
                    formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Weekly'] ? (
                    <>
                      <Form.Item

                        label={translation(props.translationCache, constant.workOrderCreationTime)}
                        name="CreationTime"
                        rules={[{ required: true }]}>
                        <TimePicker
                          style={{ width: '100%' }}
                          format={'HH:mm'}
                          onChange={(value) => handleChange(value, 'CreationTime')}
                          allowClear={false}
                        />
                      </Form.Item>
                    </>
                  ) : null}
                  {!formObject.Id &&
                    formHeader &&
                    frequencyObject &&
                    formHeader.current &&
                    formHeader.current !== null &&
                    formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Monthly'] ? (
                    <>
                      <Form.Item

                        label={translation(props.translationCache, constant.workOrderCreationTime)}
                        name="CreationTime"
                        rules={[{ required: true }]}>
                        <TimePicker
                          style={{ width: '100%' }}
                          format={'HH:mm'}
                          onChange={(value) => handleChange(value, 'CreationTime')}
                          allowClear={false}
                        />
                      </Form.Item>
                    </>
                  ) : null}
                  {formHeader &&
                    frequencyObject &&
                    formHeader.current &&
                    formHeader.current !== null &&
                    formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Weekly'] ? (
                    <>
                      <Form.Item

                        label={translation(props.translationCache, constant.selectDay)}
                        name="Days"
                        rules={[{ required: true }]}>
                        <Select
                          style={{ width: '100%' }}
                          mode={'multiple'}
                          showSearch
                          virtual={false}
                          placeholder={translation(props.translationCache, 'Select Days')}
                          onChange={(value) => handleChange(value, 'Days')}>
                          <Option value="0">
                            {translation(props.translationCache, constant.sunday)}
                          </Option>
                          <Option value="1">
                            {translation(props.translationCache, constant.monday)}
                          </Option>
                          <Option value="2">
                            {translation(props.translationCache, constant.tuesday)}
                          </Option>
                          <Option value="3">
                            {translation(props.translationCache, constant.wednesday)}
                          </Option>
                          <Option value="4">
                            {translation(props.translationCache, constant.thursday)}
                          </Option>
                          <Option value="5">
                            {translation(props.translationCache, constant.friday)}
                          </Option>
                          <Option value="6">
                            {translation(props.translationCache, constant.saturday)}
                          </Option>
                        </Select>
                      </Form.Item>
                    </>
                  ) : null}
                  {formHeader &&
                    frequencyObject &&
                    formHeader.current &&
                    formHeader.current !== null &&
                    formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Daily'] ? (
                    <>{/* Additional fields for Daily frequency can be added here */}</>
                  ) : null}
                  {formHeader &&
                    frequencyObject &&
                    formHeader.current &&
                    formHeader.current !== null &&
                    formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Monthly'] ? (
                    <>
                      <Form.Item

                        label={translation(props.translationCache, constant.selectDay)}
                        name="Days"
                        rules={[{ required: true }]}>
                        <Select
                          style={{ width: '100%' }}
                          mode={'multiple'}
                          virtual={false}
                          showSearch
                          placeholder={translation(props.translationCache, 'Select Days')}
                          onChange={(value) => handleChange(value, 'Days')}>
                          {days.map((item) => {
                            return (
                              <Option key={item} value={item}>
                                {item}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </>
                  ) : null}

                  <Form.Item

                    name="Id"
                    rules={[{ required: false }]}></Form.Item>
                </StyledBox>
              </StyledBoxHeader>
            ) : null}
          </>
        ) : SelectedWorkType && SelectedWorkType === 'Inspection Work' ? (
          <>
            <StyledBoxHeader>
              <StyledBoxLabel>
                <Typography.Title level={5}>
                  {filteredWorkTypes && filteredWorkTypes[0] && filteredWorkTypes[0]['Key']
                    ? filteredWorkTypes[0]['Key']
                    : null}
                </Typography.Title>
              </StyledBoxLabel>
              <Form.Item name="InspectionData">
                <TableView
                  form={{
                    columns: inspectionColumns,
                    datasource: formObject.InspectionData
                  }}
                  recordType={'InspectionData'}
                  saveTableViewData={(e) => saveTableViewData(e)}
                  showAddButton={true}
                  autoPopulateData={inspectionMasterList}
                />
              </Form.Item>
            </StyledBoxHeader>

            <StyledBoxHeader>
              <StyledBoxLabel>
                <Typography.Title level={5}>
                  {translation(props.translationCache, 'Schedule')}
                </Typography.Title>
              </StyledBoxLabel>
              <StyledBox>
                <Form.Item

                  label={translation(props.translationCache, constant.frequency)}
                  name="FrequencyId"
                  rules={[{ required: true }]}>
                  <Select
                    style={{ width: '100%' }}
                    placeholder={translation(props.translationCache, 'Select Frequency')}
                    onChange={(value) => handleChange(value, 'FrequencyId')}>
                    {frequencyList &&
                      Array.isArray(frequencyList) &&
                      frequencyList.map((freq, index) => {
                        return (
                          <Option key={index} value={freq.Value}>
                            {translation(props.translationCache, freq.Key)}{' '}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>

                {formHeader &&
                  formHeader.current &&
                  formHeader.current !== null &&
                  formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Weekly'] ? (
                  <>
                    <Form.Item

                      label={translation(props.translationCache, constant.selectDay)}
                      name="Days"
                      rules={[{ required: true }]}>
                      <Select
                        style={{ width: '100%' }}
                        mode={'multiple'}
                        virtual={false}
                        showSearch
                        placeholder={translation(props.translationCache, 'Select Days')}
                        onChange={(value) => handleChange(value, 'Days')}>
                        <Option value="0">
                          {translation(props.translationCache, constant.sunday)}
                        </Option>
                        <Option value="1">
                          {translation(props.translationCache, constant.monday)}
                        </Option>
                        <Option value="2">
                          {translation(props.translationCache, constant.tuesday)}
                        </Option>
                        <Option value="3">
                          {translation(props.translationCache, constant.wednesday)}
                        </Option>
                        <Option value="4">
                          {translation(props.translationCache, constant.thursday)}
                        </Option>
                        <Option value="5">
                          {translation(props.translationCache, constant.friday)}
                        </Option>
                        <Option value="6">
                          {translation(props.translationCache, constant.saturday)}
                        </Option>
                      </Select>
                    </Form.Item>
                  </>
                ) : null}
                {formHeader &&
                  frequencyObject &&
                  formHeader.current &&
                  formHeader.current !== null &&
                  formHeader.current.getFieldValue('FrequencyId') === frequencyObject['Monthly'] ? (
                  <>
                    <Form.Item

                      label={translation(props.translationCache, constant.selectDay)}
                      name="Days"
                      rules={[{ required: true }]}>
                      <Select
                        style={{ width: '100%' }}
                        mode={'multiple'}
                        virtual={false}
                        showSearch
                        placeholder={translation(props.translationCache, 'Select Days')}
                        onChange={(value) => handleChange(value, 'Days')}>
                        {days.map((item) => {
                          return (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </>
                ) : null}
              </StyledBox>
              <Form.Item
                name="Id"></Form.Item>
            </StyledBoxHeader>
          </>
        ) : null}

      </Form>
      <Modal
        open={visible}
        width={800}
        closable
        title={translation(props.translationCache, constant.selectEquipment)}
        onOk={onModalOk}
        onCancel={onModalCancel}>
        <TableSelect
          data={tableData}
          translationCache={props.translationCache}
          key="Location"
          columns={[
            {
              title: translation(props.translationCache, 'Equipment'),
              dataIndex: 'DisplayCode',
              key: 'DisplayCode',
              ...getColumnSearchProps('DisplayCode')
            },
            {
              title: translation(props.translationCache, 'Equipment Description'),
              dataIndex: 'Name',
              key: 'Name',
              ...getColumnSearchProps('Name')
            }
          ]}
          handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
        />
      </Modal>
    </StyledHomepageSides>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.userProfile,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(ELogScheduleDetails);
